import { useState } from 'react'
import {KTCard} from '../../../../_metronic/helpers'
import {PageTitle} from '../../../../_metronic/layout/core'
import {PartnerContext} from './PartnerContexts'
import {VistasAdicionalesListHeader} from './components/VistasAdicionalesListHeader'
import {VistasAdicionalesTable} from './components/VistasAdicionalesTable'

import {Row, Form, Button, Container, Col} from 'react-bootstrap'
import { VistasAdicionalesFomulario } from './components/VistasAdicionalesFormulario'
import { Vista } from './vistasadicionalesInterface'


const Breadcrumbs = [
  {
    title: 'Seguridad',
    path: '/seguridad/vistasadicionales',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DataVista:Vista = {
  _id:'', 
  nombre: '',
  url: '',
  contenido: '',
  id_empresa: '',
  estado: true
}
const VistasAdicionalesPage = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [vistaData, setVistaData] = useState<Vista>(DataVista)
  const [edit,setEdit] = useState(false)
  const [reloadTable,setReloadTable] = useState(false)
  

  return (
    <>
      <PartnerContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        vistaData, 
        setVistaData,
        edit,
        setEdit,
        reloadTable,
        setReloadTable
      }}>
        <PageTitle breadcrumbs={Breadcrumbs}>Vistas Adicionales</PageTitle>
        
          <Row className='mb-3'>
            <Col xs={6} sm>              
              <KTCard>
                <VistasAdicionalesFomulario />
              </KTCard>
            </Col>
            <Col xs={6}  sm>
              <KTCard>
                <VistasAdicionalesListHeader />
                <VistasAdicionalesTable />
              </KTCard>
            </Col>
          </Row>
      </PartnerContext.Provider>
    </>
  )
}

export {VistasAdicionalesPage}
